import React from "react";
import Layout from "../../components/Layout/Layout";

const Disclosure = () => {
    return (
        <Layout>
            <section className="page-hero">
                <div className="container">
                    <div className="eyebrow">
                        <span className="dot"></span> Important disclosures &amp; risks
                    </div>
                    <h1>Full regulatory disclosures</h1>
                </div>
            </section>

            <section className="section section-tight">
                <div className="container" style={{ maxWidth: 820 }}>
                    <article className="card" style={{ marginBottom: 18 }}>
                        <h2 style={{ marginTop: 0, marginBottom: 12, fontSize: "1.25rem" }}>1. Licensing Status</h2>
                        <p>
                            Everest Network Ltd. is licensed by the Malta Financial Services Authority as a Virtual Financial Asset
                            Service Provider under the Virtual Financial Assets Act and operates under applicable transitional
                            arrangements pending authorisation under Regulation (EU) 2023/1114 on Markets in Crypto-Assets (MiCA).
                            Everest is authorised to provide:
                        </p>
                        <ul className="check-list micro-list">
                            <li>custody of virtual financial assets (VFAs)</li>
                            <li>execution of orders in VFAs</li>
                            <li>transfer services for VFAs</li>
                            <li>reception and transmission of orders in relation to VFAs</li>
                        </ul>
                        <p style={{ marginTop: 14 }}>
                            Everest complies with the MFSA Conduct of Business Rulebook and all applicable requirements to ensure
                            information provided to clients is fair, clear and not misleading.
                        </p>
                        <p style={{ marginTop: 12 }}>
                            Everest is currently applying for authorisation as a Crypto-Asset Service Provider (CASP) under
                            Regulation (EU) 2023/1114 (MiCA). Activities continue to be provided under the VFA Act until MiCA
                            authorisation is granted.
                        </p>
                    </article>

                    <article className="card" style={{ marginBottom: 18 }}>
                        <h2 style={{ marginTop: 0, marginBottom: 12, fontSize: "1.25rem" }}>2. Classification of Tokenised Real-World Assets (RWAs)</h2>
                        <p>
                            Tokenised real-world assets (RWAs) accessible through the Everest ecosystem do not fall within MiCA’s
                            regulated categories, as they are:
                        </p>
                        <ul className="check-list micro-list">
                            <li>not Electronic Money Tokens (EMTs)</li>
                            <li>not Asset-Referenced Tokens (ARTs)</li>
                        </ul>
                        <p style={{ marginTop: 14 }}>
                            RWAs do not benefit from MiCA investor protections or from the protections applicable to regulated
                            financial instruments.
                        </p>
                    </article>

                    <article className="card" style={{ marginBottom: 18 }}>
                        <h2 style={{ marginTop: 0, marginBottom: 12, fontSize: "1.25rem" }}>3. Fiat Services and IBAN Accounts</h2>
                        <p>Fiat services offered within the Everest ecosystem—including:</p>
                        <ul className="check-list micro-list">
                            <li>IBAN-linked accounts</li>
                            <li>fiat on-ramp and off-ramp functionality</li>
                            <li>payment account access</li>
                        </ul>
                        <p style={{ marginTop: 14 }}>
                            —are provided exclusively by a licensed third-party financial institution.
                        </p>
                        <p style={{ marginTop: 12 }}>Everest does not provide:</p>
                        <ul className="check-list micro-list">
                            <li>banking services</li>
                            <li>payment services</li>
                            <li>electronic money services</li>
                        </ul>
                        <p style={{ marginTop: 14 }}>
                            All fiat-related activities are governed by the regulatory authorisation of the partner institution.
                        </p>
                    </article>

                    <article className="card" style={{ marginBottom: 18 }}>
                        <h2 style={{ marginTop: 0, marginBottom: 12, fontSize: "1.25rem" }}>4. Risk Warnings</h2>
                        <h3 style={{ fontSize: "1.05rem", marginTop: 16, marginBottom: 8 }}>Crypto-Asset Risks</h3>
                        <p>
                            Virtual financial assets (VFAs) and crypto-assets are high-risk, volatile and speculative. Their value
                            may fluctuate significantly over short periods. You may lose all the money you invest. Crypto-assets may
                            be subject to market, technology, liquidity, cybersecurity and operational risks.
                        </p>
                        <p style={{ marginTop: 10 }}>Crypto-assets may not be suitable for all investors.</p>
                        <h3 style={{ fontSize: "1.05rem", marginTop: 20, marginBottom: 8 }}>Unregulated Product Risks</h3>
                        <p>Unregulated crypto-assets—including tokenised RWAs—carry additional risks, such as:</p>
                        <ul className="check-list micro-list">
                            <li>limited secondary market availability</li>
                            <li>valuation uncertainty</li>
                            <li>operational and legal risks</li>
                            <li>lack of regulatory protections</li>
                        </ul>
                        <p style={{ marginTop: 12 }}>
                            Users should carefully evaluate whether such products align with their objectives and risk profile.
                        </p>
                    </article>

                    <article className="card" style={{ marginBottom: 18 }}>
                        <h2 style={{ marginTop: 0, marginBottom: 12, fontSize: "1.25rem" }}>5. No Investment Advice</h2>
                        <p>
                            Everest does not provide investment advice, portfolio management, or any service requiring MiFID
                            authorisation.
                        </p>
                        <p style={{ marginTop: 12 }}>
                            All information provided is for informational purposes only and does not constitute a recommendation.
                        </p>
                    </article>

                    <article className="card" style={{ marginBottom: 18 }}>
                        <h2 style={{ marginTop: 0, marginBottom: 12, fontSize: "1.25rem" }}>6. Conflicts of Interest</h2>
                        <p>
                            Everest maintains internal policies and procedures to identify, mitigate and manage potential conflicts
                            of interest. Where relevant, Everest will provide clear and prominent disclosure.
                        </p>
                    </article>

                    <article className="card" style={{ marginBottom: 18 }}>
                        <h2 style={{ marginTop: 0, marginBottom: 12, fontSize: "1.25rem" }}>7. Environmental and Sustainability Disclosures</h2>
                        <p>
                            In accordance with MiCA and applicable delegated regulations, Everest will provide sustainability and
                            environmental impact disclosures for relevant crypto-assets when authorised as a CASP. These will be
                            presented in the required regulatory format.
                        </p>
                        <p style={{ marginTop: 12 }}>
                            See our{" "}
                            <a href="/principal-adverse-impacts" style={{ color: "var(--brand)" }}>
                                Principal Adverse Impacts
                            </a>{" "}
                            disclosure for further detail on principal adverse impacts on the climate and environment.
                        </p>
                    </article>

                    <article className="card" style={{ marginBottom: 18 }}>
                        <h2 style={{ marginTop: 0, marginBottom: 12, fontSize: "1.25rem" }}>8. Contact Information</h2>
                        <p>
                            <strong>Everest Compliance Team</strong>
                            <br />
                            Email:{" "}
                            <a href="mailto:contact@everest.org" style={{ color: "var(--brand)" }}>
                                contact@everest.org
                            </a>
                        </p>
                        <p style={{ marginTop: 12 }}>
                            <strong>Registered Address:</strong> Tower Business Centre 2nd floor, TRIQ IT- TORRI, SWATAR BIRKIRKARA,
                            BKR 4013, Malta
                        </p>
                    </article>
                </div>
            </section>
        </Layout>
    );
};

export default Disclosure;
